import { ParlorDetailProps } from "@/types/parlor";
import { getParlorCostRange } from "@/utils/parlorCostRange";
import type { CompareVisitItem } from "@/utils/parlorCompareVisitStorage";

export function parlorToCompareVisit(
  parlor: ParlorDetailProps,
  region: string,
): Omit<CompareVisitItem, "ts"> {
  const range = getParlorCostRange({
    무빈소: parlor.expected_charge_sum?.["무빈소"],
    가족장: parlor.expected_charge_sum?.["가족장"],
    일반장: parlor.expected_charge_sum?.["일반장"],
  });
  const raw = parlor.images?.[0]?.url;
  return {
    id: String(parlor.id),
    name: parlor.companyname || `식장 ${parlor.id}`,
    region: region || "",
    imageUrl: typeof raw === "string" && raw ? raw : undefined,
    minPriceManwon: range?.min,
  };
}
